<template>
	<div class="discount-tag">
		<span>Up to {{ discount }}%</span>
	</div>
</template>

<script>
export default {
	props: {
		discount: {
			type: String,
			default: '0',
		},
	},
};
</script>

<style scoped lang="scss">
.discount-tag {
	background-color: #feeceb;
	border-radius: 4px;
	padding: 2px 4px;
	color: #f04438;
	font-size: 12px;
}
</style>
